import { Component, OnInit, HostListener } from "@angular/core";
import { BaseComponent } from "../../base/base.component";
import { ActivatedRoute, Router } from "@angular/router";
import { WhoAmIVM, ClientDetailVM, CountryVM, NationalityVM, CallingCodeVM } from "../../../models";
import { AccountService } from "../../../services/account.service";
import { FormBuilder, FormControl, Validators, FormGroup } from "@angular/forms";
import { Utils, minAgeValidator } from "../../../utils/utils";
import { formatMobileNumber, mobileNumberValidator, parseMobileNumber } from "../../../utils/mobile-number";
import * as moment from 'moment';

@Component({
  selector: 'account-profile',
  templateUrl: './profile.component.html'
})
export class ProfileComponent extends BaseComponent implements OnInit {

  model: ClientDetailVM;
  age: number;
  mobileCallingCode: CallingCodeVM;
  mobileLocalNumber: string = '';
  countryDropdownOpen: boolean = false;
  countryDropdownElement: HTMLElement = null;

  dropdownLeft = 0;
  dropdownTop = 0;
  dropdownWidth = 0;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private accService: AccountService,
    private fb: FormBuilder) {
    super(route);
    this.model = new ClientDetailVM();
  }

  ngOnInit(): void {
    this.model = this.route.snapshot.data['accountData'] != null ? this.route.snapshot.data['accountData'] : this.model;
    this.model.dateOfBirth = moment(this.model.dateOfBirth, 'YYYY-MM-DD').format('DD/MM/YYYY');
    this.myForm = this.fb.group({
      firstname: new FormControl(null, [Validators.required]),
      lastname: new FormControl(null, [Validators.required]),
      displayName: new FormControl(null, [Validators.required]),
      age: new FormControl(null),
      gender: new FormControl('', [Validators.required]),
      nationality: new FormControl(null, [Validators.required]),
      mobileCallingCode: new FormControl(null, [Validators.required]),
      mobile: new FormControl(null, [Validators.required, mobileNumberValidator(() => this.mobileCallingCode)]),
      addressLine1: new FormControl(null, [Validators.required]),
      addressLine2: new FormControl(null),
      city: new FormControl(null, [Validators.required]),
      postcode: new FormControl(null, [Validators.required]),
      country: new FormControl(null, [Validators.required]),
      state: new FormControl(null),
    });
    this.setMobileFieldsFromModel();
  }

  onSubmit(value: string) {
    this.markAsTouched(this.myForm);
    this.updateModelMobile();
    if (this.myForm.valid) {
      this.emitDisplayLoadingDialog(true);
      this.accService.updateProfile(this.model)
        .subscribe(returnValue => {
          if (returnValue) {
            this.showDialog("Changes saved successfully", false);
          }
          else {
            this.showDialog("Changes not saved, please try again", true);
          }
        },
          error => { this.showDialog("Changes not saved, please try again", true); },
          () => { this.emitDisplayLoadingDialog(false); }
        );
    }
  }

  onMobileCallingCodeChange() {
    this.myForm.controls['mobile'].updateValueAndValidity();
    this.updateModelMobile();
  }

  onMobileNumberChange() {
    this.updateModelMobile();
  }

  private setMobileFieldsFromModel() {
    const mobileNumber = parseMobileNumber(this.model.mobile, this.callingCodeList);
    this.mobileCallingCode = mobileNumber.callingCode;
    this.mobileLocalNumber = mobileNumber.localNumber;

    this.myForm.controls['mobileCallingCode'].setValue(this.mobileCallingCode);
    this.myForm.controls['mobile'].setValue(this.mobileLocalNumber);
  }

  private updateModelMobile() {
    this.model.mobile = formatMobileNumber(this.mobileCallingCode, this.mobileLocalNumber);
  }

  toggleCountryDropdown(event: MouseEvent): void {
    event.stopPropagation();
    this.countryDropdownElement = event.currentTarget as HTMLElement;
    this.countryDropdownOpen = !this.countryDropdownOpen;
    if (this.countryDropdownOpen) {
      this.positionCountryDropdown();
    }
  }

  selectCallingCode(item: CallingCodeVM, event: MouseEvent): void {
    event.stopPropagation();

    this.mobileCallingCode = item;

    this.myForm.controls['mobileCallingCode'].setValue(item);
    this.myForm.controls['mobileCallingCode'].markAsTouched();

    this.onMobileCallingCodeChange();

    this.countryDropdownOpen = false;
  }

  private positionCountryDropdown(): void {
    if (!this.countryDropdownOpen) {
      return;
    }

    const rect = this.countryDropdownElement.getBoundingClientRect();

    this.dropdownLeft = rect.left;
    this.dropdownTop = rect.bottom;
    this.dropdownWidth = rect.width;
  }

  @HostListener('window:resize')
  onWindowResize(): void {
    if (this.countryDropdownOpen) {
      this.positionCountryDropdown();
    }
  }

  @HostListener('window:scroll')
  onWindowScroll(): void {
    if (this.countryDropdownOpen) {
      this.positionCountryDropdown();
    }
  }

  @HostListener('document:click')
  closeCountryDropdown(): void {
    this.countryDropdownOpen = false;
  }
}
